<template>
  <div v-if="ready" :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <div :class="inputGroupClass">
        <!--Special Part Starts-->
        <div v-if="$lodash.has($slots, 'prepend')" class="input-group-prepend">
          <slot name="prepend"></slot>
        </div>
        <select
          :id="actualId"
          :class="{ 'is-invalid': form && form.errors.has(errorId) }"
          :disabled="isDisabled"
          :name="name"
          :readonly="isReadonly"
          :required="isRequired"
          :value="value"
          class="form-control custom-select"
          @change="update($event.target.value)"
        >
          <template v-if="isSimple">
            <option v-for="(option, index) in options" :key="index" :value="option">
              {{ option }}
            </option>
          </template>
          <template v-else>
            <option v-for="(option, index) in options" :key="index" :value="option[trackBy]">
              {{ option[label] }}
            </option>
          </template>
        </select>
        <div v-if="$lodash.has($slots, 'append')" class="input-group-append">
          <slot name="append"></slot>
        </div>
        <!--Special Part Ends-->
      </div>

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    trackBy: {
      default: "id",
    },
    label: {
      default: "name",
    },
    autoPopulateIfSingle: {
      default: false,
    },
  },

  computed: {
    isSimple() {
      let simple = true;
      this.options.forEach((item) => {
        if (typeof item === "object") {
          simple = false;
        }
      });

      return simple;
    },
  },

  created() {
    if (this.autoPopulateIfSingle) {
      // Only populate if:
      // 1. only one option exist for this select, and
      // 2. the current chosen value is null
      if (this.options && this.options.length === 1 && this.value === null) {
        this.update(this.options[0]);
      }
    }

    this.ready = true;
  },

  methods: {
    update(value) {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("input", value);
    },
  },
};
</script>
